<div>
    <input-label [label]="translations.zip"></input-label>
    <p-inputMask [formControl]="control" [mask]="mask" styleClass="w-100"></p-inputMask>
</div>
